import React from 'react';
import { Trans } from 'react-i18next';
import useMRFTranslation from './useMRFTranslation';

export default function T({ namespace, ...props }) {
    const t = useMRFTranslation(namespace);

    return <Trans t={t} {...props} />;
}
